// Open a linked answer on arrival and when navigating browser history.
export function initFaqAnchors() {
  const openLinkedAnswer = () => {
    let id;
    try {
      id = decodeURIComponent(window.location.hash.slice(1));
    } catch {
      return;
    }
    const item = document.getElementById(id);
    if (!item?.matches('details.faq-item')) return;

    item.getAnimations().forEach((animation) => animation.cancel());
    item.open = true;
    item.style.height = '';
    item.classList.add('is-visible');
    requestAnimationFrame(() => item.scrollIntoView({block: 'start', behavior: 'instant'}));
  };

  window.addEventListener('hashchange', openLinkedAnswer);
  openLinkedAnswer();
}
